import React from "react";
import { motion } from "framer-motion";
import { CalendarCheck, MailCheck, Sparkles, Wrench, ShieldCheck, ThumbsUp } from "lucide-react";
import { useSiteContent } from "../contexts/SiteContentContext";

const STEP_ICONS = [CalendarCheck, MailCheck, Sparkles, Wrench, ShieldCheck, ThumbsUp];
const INDENT = [
  "ml-0",
  "ml-0 sm:ml-[7%] md:ml-[12%]",
  "ml-0 sm:ml-[14%] md:ml-[24%]",
  "ml-0 sm:ml-[21%] md:ml-[36%]",
  "ml-0 sm:ml-[7%] md:ml-[12%]",
  "ml-0",
];

export default function HowItWorks() {
  const { text } = useSiteContent();
  const how = text.how_it_works || {};
  const title = how.title || "Rezervace ve 3 krocích.";
  const subtitle = how.subtitle || "Od výběru služby k nablýskanému autu — jednoduše a přehledně.";
  const steps = Array.isArray(how.steps) && how.steps.length > 0 ? how.steps : [];

  return (
    <section id="jak-to-funguje" className="relative py-24 md:py-32 tone-how overflow-hidden" data-testid="how-it-works-section">
      <div className="lit-how absolute inset-0 pointer-events-none" />
      <div className="relative max-w-[1180px] mx-auto px-[22px] md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: false, margin: "-100px" }}
          transition={{ duration: 0.7, ease: "easeOut" }} className="max-w-[560px] mb-[40px] md:mb-[50px]"
        >
          <span className="eyebrow text-akcent" data-testid="how-it-works-eyebrow">Jak to funguje</span>
          <h2 className="t-h1 mt-4 text-krem-100" data-testid="how-it-works-title">{title}</h2>
          <p className="t-body mt-4 text-tlum-dark" data-testid="how-it-works-subtitle">{subtitle}</p>
        </motion.div>

        <div className="flex flex-col">
          {steps.map((s, i) => {
            const Icon = STEP_ICONS[i % STEP_ICONS.length];
            const isLast = i === steps.length - 1;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -24 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: false, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.12, ease: "easeOut" }}
                className={`staircase-item flex items-start gap-5 max-w-[840px] ${INDENT[i % INDENT.length]} ${isLast ? "" : "pb-[26px]"}`}
                data-testid={`how-step-${i + 1}`}
              >
                <div className="relative flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center" style={{ border: "0.5px solid var(--linka-tmava)" }}>
                  <Icon className="w-6 h-6 text-akcent" />
                  {!isLast && <span className="staircase-connector" aria-hidden />}
                </div>
                <div className="pt-1.5">
                  <div className="t-label text-akcent how-step-label">Krok {i + 1}</div>
                  <h3 className="t-h3 how-step-title mt-1.5">{s.title}</h3>
                  <p className="mt-2 text-tlum-dark how-step-text" style={{ lineHeight: 1.5 }}>{s.text}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
